import classNames from 'classnames';
import { FC } from 'react';

import { useTranslation } from '../../../utils/i18n';

const classes = classNames(
  'booking-slot__btn',
  'booking-slot__btn--unavailable',
  'booking-slot__btn--no-times'
);

interface Props {
  label?: string;
}

const ClosedSlot: FC<Props> = ({ label }) => {
  const { t } = useTranslation('common');

  return (
    <div className="booking-slots">
      <button type="button" className={classes} disabled>
        {label || t('shared.closed')}
      </button>
    </div>
  );
};

export default ClosedSlot;
